import React, { useEffect, useState } from 'react';
import { Input } from 'semantic-ui-react';

/**
 * Inline edit used in the import previews. Same look as the inline edits of the
 * listings table (Semantic mini Input). `parse(text)` returns the number to commit
 * or null when the text is invalid; an empty text commits null.
 */
const EditableNumberInput = ({ value, format, parse, onCommit, ariaLabel, placeholder, width = 130, prefix }) => {
  const toText = (current) => (current === null || current === undefined ? '' : format(current));
  const [text, setText] = useState(toText(value));
  const [invalid, setInvalid] = useState(false);

  useEffect(() => {
    setText(toText(value));
    setInvalid(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const commit = () => {
    if (text.trim() === '') {
      setInvalid(false);
      if (value !== null && value !== undefined) onCommit(null);
      return;
    }
    const parsed = parse(text);
    if (parsed === null) {
      setInvalid(true);
      return;
    }
    setInvalid(false);
    setText(format(parsed));
    if (parsed !== value) onCommit(parsed);
  };

  return (
    <Input
      size="mini"
      error={invalid}
      value={text}
      placeholder={placeholder}
      aria-label={ariaLabel}
      label={prefix ? { basic: true, content: prefix } : undefined}
      labelPosition={prefix ? 'left' : undefined}
      input={{ inputMode: 'decimal', style: { textAlign: 'right', minWidth: 0 } }}
      style={{ width }}
      onChange={(_, data) => {
        setText(data.value);
        setInvalid(false);
      }}
      onBlur={commit}
      onKeyDown={(event) => {
        if (event.key === 'Enter') event.target.blur();
      }}
    />
  );
};

export default EditableNumberInput;
